import { signalStore, withHooks, withState } from '@ngrx/signals';
import { effect, inject } from '@angular/core';
import { BaseState, withCrudOperations } from '../crud.state';
import { Colorset } from '../../models/colorset';
import { withColorsetSelectors } from './colorset.selectors';
import { ColorsetService } from '../../services/colorset/colorset.service';
import { withLogging } from '../features/logger.feature';
import { ActiveUserStore } from '../user/active-user.state';

export type ColorsetState = BaseState<Colorset>;

export const initialState: ColorsetState = {
  items: {},
  loading: false,
  selectedId: '',
  selection: [],
  initialized: false,
  itemsLoaded: false,
  version: 0,
  lastPersistedId: '',
  trigger: undefined,
  entityType: 'ColorSet',
  entityLabel: 'Farbset',
  filter: {
    query: '',
    category: [],
    tags: undefined,
    products: undefined,
    published: null,
    locked: null,
    ids: undefined,
  },
};

export const ColorsetStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withCrudOperations<Colorset>(ColorsetService),
  withLogging(initialState.entityType),
  withColorsetSelectors(),
  withHooks({
    onInit(store, activeUserStore = inject(ActiveUserStore)) {
      // See category.state.ts for why this watches commune reactively
      // instead of firing once at construction time.
      effect(
        () => {
          if (activeUserStore.commune()) {
            store.loadAllItemsByPromise();
          }
        },
        { allowSignalWrites: true }
      );
    },
  })
);
